import useLocalStore from '../../../../hooks/useLocalStore.js';
import FJFavorite from '../view/FJFavorite.jsx';
import { useSelector, useDispatch } from 'react-redux';
import { useMemo } from 'react';
import FJActionTextToSpeech from '../../../../redux/action/FJActionTextToSpeech.js';
import FJTextToSpeechUtil from '../../../../util/FJTextToSpeechUtil.js';

const FJFavoriteContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const favoriteList = useSelector(state => state.textToSpeech.favoriteList);
    const voiceInfo = useSelector(state => state.textToSpeech.voiceInfo);
    const loadingFavoriteListStatus = useSelector(state => state.textToSpeech.loadingFavoriteListStatus);

    const voiceList = useMemo(() => {
        return FJTextToSpeechUtil.getFavoriteVoiceListByIds(voiceInfo, favoriteList);
    }, [voiceInfo, favoriteList]);


    const _onUse = (info, options = {}) => {
        dispatch(FJActionTextToSpeech.useVoiceItemAction(info, { ...options, isAdd: true }));
    };

    const _onRetry = () => {
        dispatch(FJActionTextToSpeech.getFavoriteAction());
    };

    return <FJFavorite list={voiceList} onUse={_onUse} loadingStatus={loadingFavoriteListStatus} onRetry={_onRetry} />;
};
export default FJFavoriteContainer;
